
import { Options, prop, Vue } from "vue-class-component";
import { ModalMessageEntities } from '@/domain/entities/MainApp';
import { ResponsePayload } from '@/domain/entities/ResponsePayload';
import { formatDateNormal } from '@/app/infrastructures/misc/Utils';

class Props {
  messageData = prop<ResponsePayload>({
    default: null,
    type: Object
  });
  productType = prop<string>({
    default: "",
    type: String
  });
  modelValue = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  emits: ["close"]
})
export default class ModalSuccessProcessOrder extends Vue.with(Props) {
  successProcessBookingModalEntities = new ModalMessageEntities({
    customWidth: "640px",
    image: "badge-success",
    imageWidth: "32",
    imageheight: "32",
    title: `
    <div>Booking berhasil!</div>
    <div class="font-normal text-sm">Nomor STT: </div>
`,
    textCancel: "Tutup",
    textSuccess: "Print termal resi",
    customButton: "w-full text-sm",
    customParentButton: "w-full",
    customWrapperButton: "w-full px-6",
    message: this.generatedPopupMessage,
    onClose: () => {
      this.$emit("update:modelValue", false);
      this.$emit("close");
    },
    onSubmit:  () => {
      this.onPrintThermalPdf(this.messageData.sttId)
    }
  });

  get generatedPopupMessage() {
    if (!this.messageData.data) return ''
    const isMonthYearIsSame = formatDateNormal(this.messageData.data.estimation_date.split(" - ")[0], "MMMM YYYY") === formatDateNormal(this.messageData.data.estimation_date.split(" - ")[1], "MMMM YYYY")
    const estimationDateStart = formatDateNormal(this.messageData.data.estimation_date.split(" - ")[0], `${isMonthYearIsSame ? 'D' : 'D MMMM YYYY'}`);
    const estimationDateEnd = formatDateNormal(this.messageData.data.estimation_date.split(" - ")[1], "D MMMM YYYY");

    return `
      <div class="flex flex-col gap-6 w-full">
        <div class="flex flex-row justify-center justify-center items-center pb-6 text-center border-b border-gray-lp-2000 relative gap-2">
          <h1 class="text-2xl underline font-bold text-red-lp-100 w-max">${this.messageData.sttNumber}</h1>
        </div>
        <div class="flex flex-col gap-3 text-sm pb-6 border-b border-gray-lp-2000">
          <div class="flex flex-row justify-between items-center">
            <div class="text-gray-lp-300">Estimasi pengiriman</div>
            <div class="text-gray-lp-800 font-semibold">${estimationDateStart} - ${estimationDateEnd}</div>
          </div>
          <div class="flex flex-row justify-between items-center">
            <div class="text-gray-lp-300">Jenis Pengiriman</div>
            <div class="text-gray-lp-300 px-2 py-0.5 bg-gray-lp-200 rounded font-medium">${this.productType}</div>
          </div>
          <div class="flex flex-row justify-between items-baseline">
            <div class="text-gray-lp-300">Penerima</div>
            <div class="text-gray-lp-800 font-semibold w-1/2 text-right">${this.messageData.data.recipient_name}</div>
          </div>
          <div class="flex flex-row justify-between items-baseline">
            <div class="text-gray-lp-300">Kecamatan, kota tujuan</div>
            <div class="text-gray-lp-800 font-semibold w-1/2 text-right">${this.messageData.data.destination_district_name}, ${this.messageData.data.destination_city_name}</div>
          </div>
        </div>
      </div>
    `
  }

  async onPrintThermalPdf(sttId: number) {
    await this.print(sttId);
  }

  async print(sttId: number) {
    const book: any = await import(
      "@/app/ui/views/shipment/booking/create-booking/payment-detail/book.vue"
    );

    await book.default.methods.printBasic(
      sttId,
      0,
      this.productType === "INTERPACK" ?
        "en" :
        "id",
      false,
      true
    )
  }
}
